import { Slot } from 'zens-router'
import { NoContextLayout } from '@dms/component'

export default function Auth() {
  return (
    <NoContextLayout>
      <Slot />
    </NoContextLayout>
  )
}
